import styled from '@emotion/styled';

import { colors, breakpoints } from '@parapet/common';

export const StyledCookieBanner = styled.div`
  background-color: #0002;
  width: 90%;
  height: 120px;
  position: absolute;
  bottom: 0;
  padding: 2rem;
  font-size: 0.8rem;
  display: flex;
  opacity: 0;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  transform: translateY(200px);
  transition: opacity 0.2s linear 0.1s,
    transform 0.6s cubic-bezier(1, 0, 0, 1);

  @media (max-height: 720px) {
    display: none;
  }
  @media (max-width: ${breakpoints.lg}) {
    width: 100%;
    height: auto;
    margin-top: 2rem;
    position: relative;
    border-radius: 0;
    flex-direction: column;
    padding: 1.5rem;
  }
  &.is-active {
    opacity: 1;
    transform: none;
  }
  > div {
    flex: 1;
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    @media (max-width: ${breakpoints.lg}) {
      display: block;
      padding: 0;
    }
  }
  h6 {
    opacity: 0.4;
    font-size: 1rem;
    margin: 0 2rem 0 1rem;
    color: ${colors.white};
    @media (max-width: ${breakpoints.lg}) {
      font-size: 12px;
      margin: 0;
    }
  }
  p {
    width: 86%;
    opacity: 0.4;
    margin: 0;
    color: ${colors.white};
    @media (max-width: ${breakpoints.lg}) {
      width: 100%;
      font-size: 11px;
      line-height: 1.4;
    }
  }
  button {
    background-color: transparent;
    width: 100px;
    margin-left: 1rem;
    cursor: pointer;
    margin-left: auto;
    border-radius: 100px;
    color: #fff;
    font-family: inherit;
    font-weight: 700;
    border: 1px solid #fff4;
    @media (max-width: ${breakpoints.lg}) {
      margin: 1rem 0 0 0;
    }
    &:hover {
      border-color: ${colors.brand};
    }
  }
`;
